module.exports = __webpack_public_path__ + "frontend/images/miles/sky-xs-25d978e36fccfb15a3013cf2fe6a2f75.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/miles/sky-xs.jpg
// module id = 324
// module chunks = 2